/* eslint complexity: ["error", 6], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 13] */
'use strict';

const ancillariesStep = require('./ancillaries_step');
const loginFactory = require('components/user_area/login/js/main');
const membershipPerksLightbox = require('components/membership/membership_perks_info_lightbox/js/main');
const {default: membershipAncillaries} = require('components/membership/membership_ancillaries/js/main');
const {default: membershipRecaptureCustomers} = require('components/membership/membership_recapture_customers/js/main');
const createWidgetLoader = require('components-framework/widget/create_widget_loader');
const PB_ITEM_TYPE = require('../enums/pricebreakdown_item_type.enum');
const priceManagerCollection = require('../collections/pricemanager.collection').getInstance();
const trackingAncillariesContinuance = require('../../tracking/ancillaries_continuance');
const trackingUtils = require('../utils/tracking.utils');
const buyerUtils = require('../handlers/buyer');
const ShoppingCart = require('od-modules/cart/cart');
const membershipSubscriptionErrorFactory = require('components/membership/membership_subscription_error/js/main');
const psd2PopupManagerFactory = require('components/psd2/psd2_popup_manager/js/main');
const fareRulesFactory = require('components/fare_rules/js/main');
const paymentButtonFactory = require('components/payment/payment_button/js/main');

const primeErrorContainerSelector = '.subscription_prime_error_container_payment';
import {dispatch} from 'od-modules/secure_store/store';
import {updateMembership} from 'od-modules/secure_store/reducers/asyncActionCreators';

let errorContainer;
const isSidebarSummary = $('.side_summary_payment').data('type') === 'sidebarsummary';

const asyncWidgets = Odigeo.autoloadWidgetsAsync({
    getPriceManagerEnhanced: ['price-breakdown-payments', 'pricemanager_enhanced'],
    getSidebar: isSidebarSummary ? ['sidebar-summary-payment', 'sidebar_summary'] : ['trip-summary-price-payment', 'trip_summary_price'],
    getSpecialrequestManager: ['specialrequest', 'special_request_manager'],
    getAncillariesModule: ['ancillaries-module', 'ancillaries_module'],
    getAncillariesModuleDetails: ['ancillaries-module-details', 'ancillaries_module'],
    getAncillariesModuleDetailsBeneathPhone: ['ancillaries-module-details-beneath-phone-number', 'ancillaries_module'],
    getAncillariesDebugInfo: ['ancillaries-debuginfo', 'ancillaries_debuginfo'],
    getHandBaggageSummary: ['hand-baggage-summary', 'hand_baggage_summary'],
    getSeatsLeftOnTop: ['seatsLeftOnTopPaymentPage', 'seats_left_on_top'],
    getBoardingOptions: ['boarding-options', 'boarding_options'],
    getMembershipManager: ['membership-manager', 'membership_manager'],
    getProgressBar: ['progress-bar-3', 'progress_bar'],
});

const widgets = Odigeo.autoloadWidgets({
    getUsersManager: ['users-manager', 'usersmanager'],
    getBinDetection: ['payment-bin-detection-manager', 'bindetectionmanager'],
    dpWaitingPage: ['dpwaiting-page', 'dp_waiting_page'],
    accommodationDetails: ['accommodation-details', 'accommodation_details'],
    getPaymentManager: ['payment-manager', 'paymentmanager'],
    getPaymentErrorManager: ['payment-error-manager', 'paymenterrormanager'],
    getInvoiceManager: ['invoice-manager', 'invoice_manager'],
    getSpecialrequestManager: ['specialrequest', 'special_request_manager'],
    getServiceoptionsTableManager: ['so-table', 'service_options_table'],
    nagManager: ['nagmanager', 'nagmanager'],
    binDetectionManager: ['payment-bin-detection-manager', 'bin_detection_manager'],
});

const widgetLoader = createWidgetLoader({
    login: ['login-header', loginFactory],
    psd2PopupManager: ['psd2-popup-manager', psd2PopupManagerFactory],
    membershipInfoLightbox: ['membership-perks-info-lightbox-payment', membershipPerksLightbox],
    membershipAncillaries: ['membership-ancillaries', membershipAncillaries.factory],
    membershipRecaptureCustomers: ['membership-recapture-customers', membershipRecaptureCustomers.factory],
    membershipSubscriptionError: ['membership-subscription-error-ancillaries', membershipSubscriptionErrorFactory],
    fareRules: ['fare-rules', fareRulesFactory],
    paymentButton: ['payment-button', paymentButtonFactory],
});

const isPrimeWidgetStepOpenFirstTime = () => Odigeo.Utils.parseJson(Odigeo.Session.get('isPrimeWidgetStepOpenFirstTime'));

const $payment = $('#payment');
var ancillariesData = null;
let updatePriceIfServiceOptionsIsPresent;
let isPrimeModuleFromShell;
let _submitBinDetectionRequest;
let updateMembershipPrices;
var bodyHeight = 0;
var footerTop = 0;
const $footer = $('#footer');
var paymentMainHeight = 0;
const $window = $(window);
const $page = $('#page');
let addProductsToShoppingCart;
var addingInsurance = false;
var invoiceData = {};
var serviceoptionsData = null;
var sidebarWidget;

const updateMembershipProduct = function() {
    dispatch(updateMembership);
};

const checkAutoApplyDiscount = async function() {
    let isAutoApplyDiscount = false;
    if (Odigeo.Membership.isMembershipAutoApplyDiscount) {
        isAutoApplyDiscount = await asyncWidgets.getPriceManagerEnhanced().get('getMembershipPerks').isAutoApplyDiscount;
    }
    return isAutoApplyDiscount;
};

addProductsToShoppingCart = () => {
    addingInsurance = true;

    if (!Odigeo._.isEmpty(invoiceData) && invoiceData.invoicemanager.invoiceRequired) {
        if (!invoiceData.invoicemanager.professional) {
            trackingUtils.trackEvent('invoice_widget', 'invoice_requested_leisure');
        }
    }
    submitProducts();
};

const submitProducts = () => {
    ShoppingCart.commit().then(() => {
        commitPayment(widgets.getPaymentManager());
    });
};

const initialize = () => {
    ancillariesData = null;
    addingInsurance = false;
};
const onTrackContinue = (pageName) => {
    var policies = [];
    var ancillariesPromise;
    var ancillariesFlexPromise;
    const trackingPageName = pageName === 'ancillaries' ? 'anc' : 'pay';

    if (Odigeo.getWidgetByID('so-table')) {
        policies.push(widgets.getServiceoptionsTableManager().get('getAddedProduct'));
    }
    if (Odigeo.getWidgetByID('ancillaries-module')) {
        ancillariesPromise = asyncWidgets.getAncillariesModule().get('getAddedPolicies');
    }

    $.when(ancillariesPromise, ancillariesFlexPromise)
        .done(function(ancillariesPolicies, ancillariesPolicyFlex) {
            var policiesToTrack = policies.concat(ancillariesPolicies, ancillariesPolicyFlex);
            trackingAncillariesContinuance.track(pageName, policiesToTrack, 'ancillaries');
            widgetLoader.get('fareRules').execute('trackFareRulesContinue', {page: trackingPageName});
        });
};

const commitPayment = (paymentManager) => {
    const buyer = Odigeo.AB.buyerWidgetPayment
        ? buyerUtils.getBuyerInfoDto($payment.find('[data-widget="passengers_manager"]')) : null;

    widgetLoader.get('paymentButton').execute('getExpectedPrice', (expectedPrice) => {
        paymentManager.execute('commit', {
            showErrorsResume: true,
            addBuyerInformationRequestDTO: buyer,
            expectedPrice,
        });
    });
};

const continueTo = async() => {
    var paymentManager = widgets.getPaymentManager();
    const isAutoApplyDiscount = await checkAutoApplyDiscount();

    onTrackContinue('payment');
    var $agreement = $('#i-agree-togglebutton');
    $agreement.closest('.payment_agree').removeAttr('data-state');

    if (Odigeo._.isNull(serviceoptionsData) && Odigeo.getWidgetByID('so-table')) {
        serviceoptionsData = {
            serviceoptions: widgets.getServiceoptionsTableManager().get('getSelectedProductOrBasic'),
        };
    }
    if (Odigeo.Membership.isMembershipProductEnabledDesktop && !isAutoApplyDiscount && !isPrimeModuleFromShell) {
        updateMembershipProduct();
    } else {
        continueWithAddProductsToShoppingCart(paymentManager);
    }
};

const continueWithAddProductsToShoppingCart = function(paymentManager) {
    // Add products to shopping cart
    if (!Odigeo._.isNull(ancillariesData) || !Odigeo._.isNull(serviceoptionsData)) {
        addProductsToShoppingCart();
    } else {
        commitPayment(paymentManager);
    }

    if (!Odigeo.AB.isMoveSpecialRequest) {
        widgets.getSpecialrequestManager().execute('analyticsEventTracking');
    }
};

const windowScroll = (function() {
    $window.scroll(function() {
        var scrollTop = $window.scrollTop();
        var sidebarMethod = isSidebarSummary ? 'stickPriceSection' : 'manageScroll';

        bodyHeight = $page.find('.body_content').height();

        footerTop = $footer.offset().top;

        paymentMainHeight = $payment.find('.left_payment_bar').height();

        if (!sidebarWidget) {
            sidebarWidget = asyncWidgets.getSidebar();
        }
        sidebarWidget.execute(sidebarMethod, {
            scrollTop: scrollTop,
            bodyHeight: bodyHeight,
            footerTop: footerTop,
            paymentMainHeight: paymentMainHeight,
        });
    });
});

const tablePaxDetails = function(page) {
    var urlTablePaxDetails = Odigeo.Settings.property('appContext') +
        Odigeo.Settings.property('widgetUrlPrefix') + 'flight_details/shortPaxInfo';
    $('.pax_info_table_details_payment').load(urlTablePaxDetails, function() {
        Odigeo.requireWidget(page, 'flight_details', function(widget) {
            widget.execute('paxDetailsUpdated');
        });
    });
};

const trackAncillariesContinueFromPax = () => {
    const pageName = Odigeo.History.getPageNameFromFragment();
    const ancillariesPromises = [];

    if (Odigeo.getWidgetByID('ancillaries-module-details')) {
        ancillariesPromises.push(asyncWidgets.getAncillariesModuleDetails().get('getAddedPolicies'));
    }
    if (Odigeo.getWidgetByID('ancillaries-module-details-beneath-phone-number')) {
        ancillariesPromises.push(asyncWidgets.getAncillariesModuleDetailsBeneathPhone().get('getAddedPolicies'));
    }

    $.when(...ancillariesPromises)
        .done((...promiseReturnValues) => {
            const policiesToTrack = Odigeo._.flatten(promiseReturnValues);
            trackingAncillariesContinuance.track(pageName, policiesToTrack, pageName);
            widgetLoader.get('fareRules').execute('trackFareRulesContinue', {page: 'pax'});
        });
};

const setIsPrimeModuleFromShell = (isMembershipSectionFromShell) => {
    isPrimeModuleFromShell = isMembershipSectionFromShell;
};

export default {
    widgets,
    asyncWidgets,
    windowScroll,
    continueTo,
    onTrackContinue,
    commitPayment,
    tablePaxDetails,
    initialize,
    setIsPrimeModuleFromShell,
    trackAncillariesContinueFromPax,
    viewEvents: function() {
        return Odigeo._.extend({
            'ancillaries_module:ancillaryAdded': 'onAncillariesModuleItemToggled',
            'ancillaries_module:addAncillaryData': 'addAncillaryData',
            'ancillaries_module:onContinuanceNagAccepted': 'onUserAcceptAncillaryNagInstance',
            'ancillaries_module:onContinuanceNagRejected': 'onUserRejectAncillaryNagInstance',
            'flight-details-payments:closeAccommodation': 'closeAccommodationDeTails',
            'flight-details-payments:heightChanged': 'onHeightChanged',
            'flight-details-payments:toggleDetails': 'onDpToggleAccommodationDetails',
            'page:afterSwitch': 'onAfterSwitchView',
            'page:scrollTo': 'onScrollTo',
            'price-breakdown-payments:priceManagerReady': 'onPriceManagerReady',
            'price-breakdown-payments:refreshData': 'onPriceManagerReady',
            'price-breakdown-payments:breakdownLoaded': 'onBreakdownLoaded',
            'price-breakdown-payments:trackContinueButtonMouseover': 'onTrackContinueButtonMouseover',
            'price-breakdown-payments:priceBreakdownToggled': 'onPriceBreakdownToggled',
            'so-table:productSelection': 'onServiceOptionViewUpdated',
            'so-table:updateBreakdown': 'onServiceOptionUpdatedBreakdown',
            'so-table:showBasicServiceOptionEvoNag': 'showBasicServiceOptionEvoNag',
            'so-table:setServiceOptionsEvoNagAlreadyShown': 'setServiceOptionsEvoNagAlreadyShown',
            'nagmanager:addRecommendedSoEvo': 'onAddRecommendedSoEvo',
            'nagmanager:addBasicSoEvo': 'onAddBasicSoEvo',
            'specialrequest:clearValidationErrors': 'onSpecialrequestClearValidationErrors',
            'trip-summary-price-payment:changeBackPage': 'goToPassengerDetails',
            'trip-summary-price-payment:toggleDetails': 'onDpToggleAccommodationDetails',
            'sidebar-summary-payment:toggleDetails': 'onDpToggleAccommodationDetails',
            'membership:refreshWidgets': 'onMembershipRefreshWidgets',
            'shoppingcart-manager:requestCompletedSuccessfully': 'onSCManagerRequestCompletedSuccessfully',
            'membership-subscription-error-payment:tryAgain': 'onSubscriptionErrorTryAgain',
            'membership-subscription-error-payment:cancel': 'onSubscriptionErrorRemovePrime',
            ...membershipAncillaries.createEventsMap('membership-ancillaries'),
            'update-membership-subscription:fail': 'onMembershipSubscriptionError',
            'update-membership-subscription:success': 'onMembershipSubscriptionSuccess',
            'ancillariesStep:toggleShowMembershipAncillariesWidget': 'toggleShowMembershipAncillariesWidget',
            'ancillariesStep:toggleShowMembershipRecaptureWidget': 'toggleShowMembershipRecaptureWidget',
            'ancillariesStep:toggleShowSubscriptionManagerDesktopContainer': 'toggleShowSubscriptionManagerDesktopContainer',
            'ancillariesStep:scrollToSubscriptionManagerDesktopContainer': 'scrollToSubscriptionManagerDesktopContainer',
            'ancillariesStep:scrollToMembershipSectionKnowMoreLink': 'scrollToMembershipSectionKnowMoreLink',
        });
    },

    eventHandlers: function() {
        return Odigeo._.extend({
            onPromotionalCodesUpdatePrices: function() {
                asyncWidgets.getPriceManagerEnhanced().execute('reloadPrices');
            },
            onSCManagerRequestCompletedSuccessfully: function() {
                if (!addingInsurance) {
                    widgets.getPaymentManager().execute('getPaymentOptions');
                } else {
                    addingInsurance = false;
                    commitPayment(widgets.getPaymentManager());
                }
            },
            onPaymentValidationSuccess: function() {
                continueTo();
            },
            refreshOfferPricesTextSize: function() {
                asyncWidgets.getPriceManagerEnhanced().execute('refreshOfferPricesTextSize');
            },
            onPriceBreakdownToggled: function() {
                this.refreshOfferPricesTextSize();
            },
            onMembershipRefreshWidgets: function() {
                widgetLoader.get('login').execute('launchPriceMemberDisplay');
            },
            // This event accepts either an array of error objects or a single error object in the following
            // format: {type: '', validationResult: ''}
            onUpdateFlagPriceManager: function(flag) {
                asyncWidgets.getPriceManagerEnhanced().execute('updateFlag', flag);
            },
            onServiceOptionViewUpdated: function(item) {
            },
            onServiceOptionUpdatedBreakdown: function(data) {
                asyncWidgets.getPriceManagerEnhanced().execute('priceHandler', data);
            },
            setServiceOptionsEvoNagAlreadyShown: function(price) {
                widgets.nagManager().execute('setServiceOptionsEvoNagAlreadyShown');
            },
            onAddRecommendedSoEvo: function() {
                widgets.getServiceoptionsTableManager().execute('addRecommendedSo');
            },
            onAddBasicSoEvo: function() {
                widgets.getServiceoptionsTableManager().execute('addBasicSo');
            },
            showBasicServiceOptionEvoNag: function(price) {
                widgets.nagManager().execute('showBasicServiceOptionEvoNag', price);
            },
            onBreakdownLoaded: function() {
                _submitBinDetectionRequest('getCcSelectedName');
                widgets.getPaymentManager().execute('isStoredCardSelected');
            },

            trackMembershipInfo: function() {
                if (Odigeo.Utils.readCookie('ua_dimension31') === 'subscriber') {
                    trackingUtils.setCustomDimension(32, window.tc_vars['user_prime_eligibility']);
                }
            },
            onPriceManagerReady: function() {
                updatePriceIfServiceOptionsIsPresent();

                $('input[name=agree]').off('change').on('change', function() {
                    if ($('input[name=agree]').prop('checked')) {
                        $('.pricebreakdown_remember_tooltip').addClass('hidden');
                    }
                });

                Odigeo.trigger('reprice-manager:checkRepricing', '#repricing-notification-payment');
                Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), $('.flightsummary_layover_hint_payment'), {
                    events: {
                        hover: true,
                    },
                });
                widgets.getPaymentManager().execute('updateFees');
            },

            onScrollTo: function(offset, options) {
                var top = Odigeo._.isObject(offset) && !Odigeo._.isUndefined(offset.top) ? offset.top : 0;
                var defaultOptions = {
                    duration: 500,
                    easing: 'swing',
                };
                $('html, body').animate({
                    scrollTop: top,
                }, options ? options : defaultOptions);
            },

            onHeightChanged: function() {
                $('#payment').find('.scroll_area').trigger('updateDimensions');
            },

            onSpecialrequestErrorsResume: function(errorList) {
                var $errorContainer = $payment.find('.specialrequest_validation_errors');
                var errorTxt = '';
                var txt;
                Odigeo._.each(errorList, function(iter) {
                    txt = $('[name="' + iter.name + '"]').data(iter.errorType);
                    errorTxt = errorTxt + '<li>' + txt + '</li>';
                });
                $errorContainer.html(errorTxt);
            },

            onSpecialrequestClearValidationErrors: function() {
                $payment.find('.specialrequest_validation_errors').empty();
            },

            onAfterSwitchView: function() {
                this.onScrollTo(0, 100);
            },

            goToPassengerDetails: function() {
                window.history.back();
            },

            onDpToggleAccommodationDetails: function(settings) {
                widgets.accommodationDetails().execute('process', settings);
            },

            closeAccommodationDeTails: function() {
                widgets.accommodationDetails().execute('closeDetails');
            },

            onUserAcceptAncillaryNagInstance: function($el) {
                Odigeo.Utils.scrollToElement($el);
            },
            onUserRejectAncillaryNagInstance: function() {
                ancillariesStep.openAncillariesStep();
            },

            onTrackContinueButtonMouseover: function() {
                var paymentManager = widgets.getPaymentManager();
                if (paymentManager.get('getPaymentMethod') === 'CREDITCARD' && !paymentManager.get('isValid')) {
                    var $tooltipPaymentMethod = $('.payment_method_remember_tooltip');
                    if ($tooltipPaymentMethod.hasClass('hidden')) {
                        trackingUtils.trackEvent('inline_bubbles', 'payment_form_bubble_appearances');
                        $tooltipPaymentMethod.removeClass('hidden');
                    }
                }
                if (!$('input[name=agree]').prop('checked')) {
                    var $tooltipPriceBreakdown = $('.pricebreakdown_remember_tooltip');
                    if ($tooltipPriceBreakdown.hasClass('hidden')) {
                        // Analytics: event tracking
                        trackingUtils.trackEvent('inline_bubbles', 'conditions_bubble_appearances');
                        $tooltipPriceBreakdown.removeClass('hidden');
                    }
                }
            },
            onAncillariesModuleItemToggled: function(item) {
            },
            addAncillaryData: function(data) {
                if (Odigeo._.isEmpty(ancillariesData)) {
                    ancillariesData = {
                        insurances: [],
                    };
                }

                if (data.selected) {
                    ancillariesData.insurances.push(data.id);
                } else {
                    ancillariesData.insurances.splice(ancillariesData.insurances.indexOf(data.id), 1);
                }

                switch (data.pbdType) {
                    case PB_ITEM_TYPE.REBOOKING_INSURANCE:
                        ancillariesStep.setSkipByRebooking(data.selected);
                        break;
                    case PB_ITEM_TYPE.CANX_INSURANCE:
                        ancillariesStep.setSkipByCanx(data.selected);
                        break;
                    default:
                        break;
                }
            },

            trackContinueWithAncillaries: function() {
                onTrackContinue();
            },

            onUpdateMembershipPricePayment(hasToApplyDiscount) {
                const {isMembershipProductEnabledDesktop} = Odigeo.Membership;
                priceManagerCollection.setMembershipPerksIncludedPrice(hasToApplyDiscount);
                if (isMembershipProductEnabledDesktop) {
                    widgets.getPaymentManager().execute('updatePaymentOptions', hasToApplyDiscount);
                }

                if (Odigeo.Membership.isMembershipFlexibilityD && hasToApplyDiscount) {
                    asyncWidgets.getAncillariesModule().execute('toggleAncillaryOfferIfExists', 'FLEXRB156', false);
                }
            },

            onUpdatePageStatus(data) {
                updateMembershipPrices(ancillariesStep.isOpened() ? !data.isUserSubscribed : data.isPriceWithoutDiscountSelected);
                if (Odigeo.Membership.isMembershipFlexibilityD) {
                    toggleFlexibility(data);
                }
            },

            onOpenMembershipPerksInfoLightbox() {
                if (Odigeo.Membership.isFreeTrialLimitationActive) {
                    widgetLoader.remove('membershipInfoLightbox', 'membership_perks_info_lightbox');
                }
                widgetLoader.get('membershipInfoLightbox').execute('openMembershipPerksInfoLightbox');
            },

            onOpenLoginForm() {
                widgetLoader.get('login').execute('openModalLogin');
            },
            onSubscriptionErrorTryAgain() {
                // this will call again the update-membership-subscription and then success or failure
                widgetLoader.get('membershipAncillaries').execute('updateMembershipProduct');
                $page.find(primeErrorContainerSelector).removeClass('open');
            },
            onSubscriptionErrorRemovePrime() {
                // this remove the membership and continue
                widgetLoader.get('membershipAncillaries').execute('removePrime');
                $page.find(primeErrorContainerSelector).removeClass('open');
                this.onMembershipSubscriptionSuccess();
            },
            onMembershipSubscriptionError() {
                widgetLoader.get('psd2PopupManager').execute('toggleWaiting', false);
                if (!errorContainer) {
                    errorContainer = membershipSubscriptionErrorFactory.create({
                        id: 'membership-subscription-error-payment',
                        el: $page.find(primeErrorContainerSelector),
                        options: {
                            page: 'pay',
                            template: 'main',
                        },
                    });
                }
                errorContainer.execute('renderTemplate', false);
                $page.find(primeErrorContainerSelector).addClass('open');
            },
            onMembershipSubscriptionSuccess() {
                const paymentManager = widgets.getPaymentManager();
                continueWithAddProductsToShoppingCart(paymentManager);
            },
            toggleShowMembershipAncillariesWidget() {
                widgetLoader.get('membershipAncillaries').execute('toggleShowMembershipAncillariesWidget');
            },
            toggleShowSubscriptionManagerDesktopContainer() {
                $('#subscription-manager-desktop-container').toggleClass('odf-hidden', !isPrimeWidgetStepOpenFirstTime());
            },
            toggleShowMembershipRecaptureWidget() {
                widgetLoader.get('membershipRecaptureCustomers').execute('toggleShowMembershipRecaptureWidget');
            },
            scrollToSubscriptionManagerDesktopContainer() {
                const $subscriptionContainer = $payment.find('#subscription-manager-desktop-container');
                $subscriptionContainer.length && Odigeo.Utils.scrollToElement($subscriptionContainer);
            },
            scrollToMembershipSectionKnowMoreLink() {
                const $knowMore = $payment.find('#membership-section')?.find('#know-more-link');

                $knowMore.length && Odigeo.Utils.scrollToElement($knowMore, {
                    avoidDefaultOffset: true,
                    animationSpeed: 1000,
                    delay: 500,
                });
            },
        });
    },
};

Odigeo.bind('complete:serviceoptions', function(data) {
    if (data.type === 'success') {
        serviceoptionsData = {
            serviceoptions: data.data,
        };
    }
}, this);

updateMembershipPrices = function(isPriceWithoutDiscountSelected) {
    priceManagerCollection.setMembershipPerksIncludedPrice(!isPriceWithoutDiscountSelected);
    widgets.getPaymentManager().execute('changePaymentMethod');
};

updatePriceIfServiceOptionsIsPresent = function() {
    widgets.getServiceoptionsTableManager().execute('updateBreakdownPrices');
};

const toggleFlexibility = ({isPriceWithoutDiscountSelected, isUserSubscribed}) => {
    ancillariesStep.toggleMembershipFlexibility(isUserSubscribed || !isPriceWithoutDiscountSelected);
};
